import { XIcon } from "@/icons";
import { Button } from "@/kit/ui/button";
import {
  ResponsiveSheetClose,
  ResponsiveSheetFooter,
  ResponsiveSheetHeader,
  ResponsiveSheetTitle,
} from "@/kit/ui/responsive-sheet";
import { Skeleton } from "@/kit/ui/skeleton";
import { PropsWithChildren, ReactNode } from "react";
import { FormattedMessage } from "react-intl";

interface DatasetAsideContentSheetFooterProps {
  disabled?: boolean;
}

export function DatasetAsideContentSheetFooter({
  disabled,
}: DatasetAsideContentSheetFooterProps) {
  return (
    <ResponsiveSheetFooter className="flex flex-row justify-between items-center sm:p-6 px-4 pt-4 pb-8 border-t border-t-grey-200 gap-5">
      <ResponsiveSheetClose asChild>
        <Button size="md" variant="secondary" className="w-full">
          <FormattedMessage defaultMessage="Discard changes" />
        </Button>
      </ResponsiveSheetClose>
      <Button size="md" type="submit" disabled={disabled} className="w-full">
        <FormattedMessage defaultMessage="Save changes" />
      </Button>
    </ResponsiveSheetFooter>
  );
}

interface DatasetAsideContentSheetHeaderProps extends PropsWithChildren {
  title: ReactNode;
}

export function DatasetAsideContentSheetHeader(
  props: DatasetAsideContentSheetHeaderProps,
) {
  return (
    <ResponsiveSheetHeader className="flex flex-col sm:p-6 px-4 pt-4 pb-5 border-b border-t-grey-200">
      <div className="w-full flex justify-between items-center">
        <ResponsiveSheetTitle>
          <p className="text-xl font-semibold text-grey-900">{props.title}</p>
        </ResponsiveSheetTitle>
        <ResponsiveSheetClose asChild>
          <Button variant="tertiary" size="md" hue="grey" icon>
            <XIcon className="w-5 h-5" />
          </Button>
        </ResponsiveSheetClose>
      </div>
      {props.children}
    </ResponsiveSheetHeader>
  );
}

export function DatasetAsideContentSheetSkeleton() {
  return (
    <div className="flex items-center justify-between">
      <Skeleton className="h-4 w-32 rounded">
        <span />
      </Skeleton>
      <div className="flex items-center gap-1">
        <Skeleton className="h-5 w-5 rounded">
          <span />
        </Skeleton>
        <Skeleton className="h-4 w-10 rounded">
          <span>000</span>
        </Skeleton>
      </div>
    </div>
  );
}
